import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import CategoryAdd from '../../../../features/category/CategoryAdd';
import CategoryEdit from '../../../../features/category/CategoryEdit';
import CategoryList from '../../../../features/category/CategoryList';

const CategoryRoute = () => [
  <Route path={ROUTES.CATEGORY.ADD} key={ROUTES.CATEGORY.ADD} component={CategoryAdd} />,
  <Route path={ROUTES.CATEGORY.EDIT} key={ROUTES.CATEGORY.EDIT} component={CategoryEdit} />,
  <Route path={ROUTES.CATEGORY.LIST} key={ROUTES.CATEGORY.LIST} component={CategoryList} />,
];

export default CategoryRoute;
